import React from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'antd';
import axios from 'axios';
import styled from 'styled-components';

import { API_ROOT } from 'containers/App/constants';
import { makeSelectAuthUser } from 'containers/App/selectors';

const A = styled.a`
  padding: 0 0.5em;
`;

interface IReportProps {
  path: string;
  id: any;
  name: string;
  fileType?: string;
  isButton?: boolean;
  buttonText?: string;
}

const authUserSelector = makeSelectAuthUser();

const Report: React.FC<IReportProps> = ({
  path,
  id,
  name,
  fileType,
  isButton,
  buttonText = 'Button'
}) => {
  const authUser = useSelector(authUserSelector) as any;

  const handleClick = (evt: React.MouseEvent) => {
    evt.preventDefault();

    const headers = {
      Authorization: `Bearer ${authUser.bearer_token}`
    };

    axios
      .get(`${API_ROOT}${path}`, { headers, responseType: 'blob' })
      .then(response => {
        // hacky download trigger via synthesised click on a temp <a>
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${name}_${id}.${fileType || 'xlsx'}`);
        link.dispatchEvent(
          new MouseEvent('click', { bubbles: true, cancelable: true, view: window })
        );
      })
      .catch(() => {
        // TODO: handle error
      });
  };

  if (isButton) {
    return (
      <Button type="primary" size="large" onClick={handleClick}>
        {buttonText}
      </Button>
    );
  }
  return (
    <A title={name} onClick={handleClick}>
      {name}
    </A>
  );
};

export default Report;
